import routes from "@/constants/routes";

import { LandingNavLink } from "./types";

export const NowLinkItemsData: LandingNavLink[] = [
  {
    caption: "How it works",
    href: routes.howItWorks,
  },
  {
    caption: "Properties",
    href: "/properties",
    items: [
      { caption: "Wandsworth", href: routes.properties.wandsworth },
      { caption: "Hayes", href: routes.properties.hayes },
      { caption: "Harrow", href: routes.properties.harrow },
      { caption: "Southall", href: routes.properties.southall },
      { caption: "Tell us where you want to live", href: routes.register },
      { caption: "Browse all homes", href: routes.searchHomes },
    ],
  },
  {
    caption: "FAQs",
    href: routes.faqs,
  },
  {
    caption: "About",
    items: [
      { caption: "Our story", href: routes.about },
      { caption: "First time buyers", href: routes.firstTimeBuyers },
      { caption: "Key workers", href: routes.keyWorkers },
      { caption: "Success stories", href: routes.customerReviews },
      { caption: "Blog", href: routes.blog },
      { caption: "Careers", href: "mailto:careers@keyzy.com" },
      { caption: "Referrals", href: routes.refer },
      { caption: "Contact us", href: routes.contact },
    ],
    href: "",
  },
];
export const NowLinkItemsAuth: LandingNavLink[] = [
  ...NowLinkItemsData,
  { caption: "     ", href: "" },
  // Blank item to create space between nav links and login button to stop jerking when the login button appears
];

export const NowLinkItems: LandingNavLink[] = [
  ...NowLinkItemsData,
  { caption: "Login", href: routes.dashboard.login },
];
